// DO NOT EDIT -- generated from fs/api/segment/values.proto

import * as protobuf from '../../../google/protobuf';

export interface StringValue {
  value: string;
}

export interface RepeatedStringValue {
  value: string[];
}

export interface NumericValue {
  value: protobuf.int64;
}

export interface NumericRangeValue {
  value: NumericRange | null;
}

export interface NumericRange {
  start: protobuf.int64;
  end: protobuf.int64;
}

export interface RepeatedNumericValue {
  value: protobuf.int64[];
}

export interface FloatValue {
  /** We call these "float" everywhere, but still want to represent with 64 bit double */
  value: number;
}

export interface FloatRangeValue {
  value: FloatRange | null;
}

export interface FloatRange {
  start: number;
  end: number;
}

export interface RepeatedFloatValue {
  value: number[];
}

export interface BoolValue {
  value: boolean;
}

export interface DurationValue {
  value: protobuf.duration | null;
}

export interface DurationRangeValue {
  value: DurationRange | null;
}

export interface DurationRange {
  start: protobuf.duration | null;
  end: protobuf.duration | null;
}

export interface RepeatedDurationValue {
  value: protobuf.duration[];
}

export interface DateValue {
  value: string;
}

export interface DateRangeValue {
  value: TimeRange | null;
}

export interface UrlValue {
  value: Url[];
}

export interface NamedCustomEventValue {
  name: string;
}

export interface BrowserValue {
  value: Browser[];
}

export interface DeviceValue {
  value: Device[];
}

export interface PlatformValue {
  value: Platform[];
}

export interface NativePlatformValue {
  value: NativePlatform[];
}

export interface OSValue {
  value: OS[];
}

export interface CustomFieldRepeatedStringValue {
  value: string[];
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) */
  spec?: string;
}

export namespace CustomFieldRepeatedStringValue {
  export enum field {
    name = 2,
    /** if spec, could be *any* scope (not implied by parent operator) */
    spec = 3
  }

  export function field_oneof(m: CustomFieldRepeatedStringValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface CustomFieldFloatValue {
  /** We call these "float" everywhere, but still want to represent with 64 bit double */
  value: number;
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
  spec?: string;
}

export namespace CustomFieldFloatValue {
  export enum field {
    name = 2,
    /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
    spec = 3
  }

  export function field_oneof(m: CustomFieldFloatValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface CustomFieldFloatRangeValue {
  value: FloatRange | null;
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
  spec?: string;
}

export namespace CustomFieldFloatRangeValue {
  export enum field {
    name = 2,
    /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
    spec = 3
  }

  export function field_oneof(m: CustomFieldFloatRangeValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface CustomFieldRepeatedFloatValue {
  /** We call these "float" everywhere, but still want to represent with 64 bit double */
  value: number[];
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
  spec?: string;
}

export namespace CustomFieldRepeatedFloatValue {
  export enum field {
    name = 2,
    /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
    spec = 3
  }

  export function field_oneof(m: CustomFieldRepeatedFloatValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface CustomFieldIntValue {
  value: protobuf.int64;
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
  spec?: string;
}

export namespace CustomFieldIntValue {
  export enum field {
    name = 2,
    /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
    spec = 3
  }

  export function field_oneof(m: CustomFieldIntValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface CustomFieldIntRangeValue {
  value: NumericRange | null;
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
  spec?: string;
}

export namespace CustomFieldIntRangeValue {
  export enum field {
    name = 2,
    /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
    spec = 3
  }

  export function field_oneof(m: CustomFieldIntRangeValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface CustomFieldRepeatedIntValue {
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
  spec?: string;
  value: protobuf.int64[];
}

export namespace CustomFieldRepeatedIntValue {
  export enum field {
    name = 1,
    /** if spec, could be *any* scope (not implied by parent operator) and *any* numeric type (conversions handled) */
    spec = 3
  }

  export function field_oneof(m: CustomFieldRepeatedIntValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface CustomFieldBoolValue {
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) */
  spec?: string;
  value: boolean;
}

export namespace CustomFieldBoolValue {
  export enum field {
    name = 1,
    /** if spec, could be *any* scope (not implied by parent operator) */
    spec = 3
  }

  export function field_oneof(m: CustomFieldBoolValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface CustomFieldDateValue {
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) */
  spec?: string;
  value: string;
}

export namespace CustomFieldDateValue {
  export enum field {
    name = 1,
    /** if spec, could be *any* scope (not implied by parent operator) */
    spec = 3
  }

  export function field_oneof(m: CustomFieldDateValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface CustomFieldDateRangeValue {
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) */
  spec?: string;
  value: TimeRange | null;
}

export namespace CustomFieldDateRangeValue {
  export enum field {
    name = 1,
    /** if spec, could be *any* scope (not implied by parent operator) */
    spec = 3
  }

  export function field_oneof(m: CustomFieldDateRangeValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface CustomFieldIsSetValue {
  name?: string;
  /** if spec, could be *any* scope (not implied by parent operator) */
  spec?: string;
}

export namespace CustomFieldIsSetValue {
  /** Value is omitted because it is always None */
  export enum field {
    name = 1,
    /** if spec, could be *any* scope (not implied by parent operator) */
    spec = 2
  }

  /** Value is omitted because it is always None */
  export function field_oneof(m: CustomFieldIsSetValue): { opt: field.name, val: string } | { opt: field.spec, val: string } | null {
    if (m.name != null) { return { opt: field.name, val: m.name } }
    if (m.spec != null) { return { opt: field.spec, val: m.spec } }
    return null;
  }
}

export interface NoneValue {
}

export interface PinchGestureTypeValue {
  value: PinchGesture;
}

export interface SeenVisibilityTypeValue {
  value: SeenVisibility;
}

export interface ErrorClickTypeValue {
  value: ErrorClickType[];
}

export interface DatalossTypeValue {
  value: DatalossType[];
}

export interface SessionTypeValue {
  value: SessionType[];
}

export interface SuspiciousActivityTypeValue {
  value: SuspiciousActivityType[];
}

export interface SuspiciousActivityCategoryValue {
  value: SuspiciousActivityCategory[];
}

export interface Url {
  value: string;
  category: UrlCategory;
}

export interface TimeRange {
  /** RFC 3339 timestamps or relative solr timestamps. */
  startTime: string;
  /** RFC 3339 timestamps or relative solr timestamps. */
  endTime: string;
}

/** Designed to be backwards compatable with RepeatedNumericValue */
export interface RepeatedPageRefValue {
  /** Page Id */
  value: protobuf.int64[];
  /** Spec object slug */
  spec: string[];
}

/** Designed to be backwards compatable with RepeatedStringValue */
export interface RepeatedNamedElementValue {
  /** Named Element Id */
  value: string[];
  /** Spec object slug */
  spec: string[];
}

export enum TimeInterval {
  TIME_INTERVAL_INVALID = 0,
  /**
   * Range boundaries are clamped to clean interval boundaries
   * for hour and day intervals.
   * there is a limit on maximum minute buckets (3 hours currently)
   */
  TIME_INTERVAL_MINUTE = 6,
  /** there is a limit on maximum hourly buckets (24 hours currently) */
  TIME_INTERVAL_HOUR = 1,
  /** computes data points for each day in the time range */
  TIME_INTERVAL_DAY = 2,
  /** computes data points for each 7 days in the time range */
  TIME_INTERVAL_WEEK = 3,
  /** computes data points for each month in the time range */
  TIME_INTERVAL_MONTH = 4,
  TIME_INTERVAL_ENTIRE_RANGE = 5
}

export enum UrlCategory {
  URL_INVALID = 0,
  URL_FULL = 1,
  URL_HOST = 2,
  /** combined path (hash and standard) */
  URL_PATH = 3,
  URL_STANDARD_PATH = 7,
  URL_HASH_PATH = 8,
  /** combined query (hash and standard) */
  URL_QUERY = 4,
  URL_STANDARD_QUERY = 9,
  URL_HASH_QUERY = 10,
  URL_FRAGMENT = 5,
  URL_NEW_PATH = 6
}

export enum Browser {
  BROWSER_INVALID = 0,
  BROWSER_UNKNOWN = 1,
  BROWSER_CHROME = 2,
  BROWSER_IE = 3,
  BROWSER_EDGE = 4,
  BROWSER_FIREFOX = 5,
  BROWSER_SAFARI = 6,
  BROWSER_OPERA = 7,
  BROWSER_ROBOT = 8,
  BROWSER_YANDEX = 9,
  BROWSER_MOBILEAPP = 10,
  BROWSER_COCCOC = 11,
  BROWSER_CUSTOMAGENT = 12,
  BROWSER_CUSTOMMOBILEAGENT = 13,
  BROWSER_DUCKDUCKGO = 14,
  BROWSER_ELECTRON = 15,
  BROWSER_LYNX = 16,
  BROWSER_MOZILLAOTHER = 17,
  BROWSER_SEAMONKEY = 18,
  BROWSER_UCWEB = 19
}

export enum Device {
  DEVICE_INVALID = 0,
  DEVICE_UNKNOWN = 1,
  DEVICE_DESKTOP = 2,
  DEVICE_MOBILE = 3,
  DEVICE_TABLET = 4,
  DEVICE_ROBOT = 5
}

export enum Platform {
  PLATFORM_INVALID = 0,
  PLATFORM_WEB = 1,
  PLATFORM_NATIVEMOBILE = 2,
  PLATFORM_SERVER = 3
}

export enum OS {
  OS_INVALID = 0,
  OS_UNKNOWN = 1,
  OS_WINDOWS = 2,
  OS_OSX = 3,
  OS_CHROME = 4,
  OS_ANDROID = 5,
  OS_IOS = 6,
  OS_LINUX = 7,
  OS_WINDOWSPHONE = 8,
  OS_ROBOT = 9
}

export enum NativePlatform {
  NATIVE_PLATFORM_INVALID = 0,
  NATIVE_PLATFORM_WEB = 1,
  NATIVE_PLATFORM_ANDROID = 2,
  NATIVE_PLATFORM_IOS = 3
}

export enum PinchGesture {
  PINCH_GESTURE_INVALID = 0,
  PINCH_GESTURE_SCALE_IN = 1,
  PINCH_GESTURE_SCALE_OUT = 2
}

export enum SeenVisibility {
  SEEN_VISIBILITY_UNKNOWN = 0,
  SEEN_VISIBILITY_IN_VIEWPORT = 1,
  SEEN_VISIBILITY_NOT_IN_VIEWPORT = 2
}

export enum ErrorClickType {
  ERROR_CLICK_TYPE_INVALID = 0,
  ERROR_CLICK_TYPE_UNKNOWN = 1,
  ERROR_CLICK_TYPE_CONSOLE = 2,
  ERROR_CLICK_TYPE_EXCEPTION = 3
}

export enum DatalossType {
  DATALOSS_TYPE_NONE = 0,
  DATALOSS_TYPE_PAYMENT_CARD = 1,
  DATALOSS_TYPE_EMAIL = 2,
  DATALOSS_TYPE_SSN = 3,
  DATALOSS_TYPE_PASSWORD = 4
}

export enum SessionType {
  SESSION_TYPE_INVALID = 0,
  SESSION_TYPE_LIVE = 1,
  SESSION_TYPE_PREVIEW = 2
}

export enum SuspiciousActivityType {
  SUSPICIOUS_ACTIVITY_TYPE_INVALID = 0,
  SUSPICIOUS_ACTIVITY_TYPE_FRAUD = 1,
  SUSPICIOUS_ACTIVITY_TYPE_AUTOMATION = 3
}

export enum SuspiciousActivityCategory {
  SUSPICIOUS_ACTIVITY_CATEGORY_INVALID = 0,
  SUSPICIOUS_ACTIVITY_CATEGORY_SQL_INJECTION = 1,
  SUSPICIOUS_ACTIVITY_CATEGORY_XSS = 2,
  SUSPICIOUS_ACTIVITY_CATEGORY_CREDENTIAL_PAIR = 3,
  SUSPICIOUS_ACTIVITY_CATEGORY_MULTIPLE_EMAILS = 4,
  SUSPICIOUS_ACTIVITY_CATEGORY_VENDOR_IP = 5,
  SUSPICIOUS_ACTIVITY_CATEGORY_IDLE_TIMEOUT = 6
}
